import React, { useMemo } from 'react';
import _ from 'underscore';
import {
  mergeClasses, Button
} from '@fluentui/react-components';

const ViewAllIcon = () => (
  <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 11C8.82843 11 9.5 11.6716 9.5 12.5V16.5C9.5 17.3284 8.82843 18 8 18H4C3.17157 18 2.5 17.3284 2.5 16.5V12.5C2.5 11.6716 3.17157 11 4 11H8ZM17 11C17.8284 11 18.5 11.6716 18.5 12.5V16.5C18.5 17.3284 17.8284 18 17 18H13C12.1716 18 11.5 17.3284 11.5 16.5V12.5C11.5 11.6716 12.1716 11 13 11H17ZM8 12H4C3.72386 12 3.5 12.2239 3.5 12.5V16.5C3.5 16.7761 3.72386 17 4 17H8C8.27614 17 8.5 16.7761 8.5 16.5V12.5C8.5 12.2239 8.27614 12 8 12ZM17 12H13C12.7239 12 12.5 12.2239 12.5 12.5V16.5C12.5 16.7761 12.7239 17 13 17H17C17.2761 17 17.5 16.7761 17.5 16.5V12.5C17.5 12.2239 17.2761 12 17 12ZM8 2C8.82843 2 9.5 2.67157 9.5 3.5V7.5C9.5 8.32843 8.82843 9 8 9H4C3.17157 9 2.5 8.32843 2.5 7.5V3.5C2.5 2.67157 3.17157 2 4 2H8ZM17 2C17.8284 2 18.5 2.67157 18.5 3.5V7.5C18.5 8.32843 17.8284 9 17 9H13C12.1716 9 11.5 8.32843 11.5 7.5V3.5C11.5 2.67157 12.1716 2 13 2H17ZM8 3H4C3.72386 3 3.5 3.22386 3.5 3.5V7.5C3.5 7.77614 3.72386 8 4 8H8C8.27614 8 8.5 7.77614 8.5 7.5V3.5C8.5 3.22386 8.27614 3 8 3ZM17 3H13C12.7239 3 12.5 3.22386 12.5 3.5V7.5C12.5 7.77614 12.7239 8 13 8H17C17.2761 8 17.5 7.77614 17.5 7.5V3.5C17.5 3.22386 17.2761 3 17 3Z" fill="#424242" />
  </svg>
);

const ViewLessIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M2 4.5C2 4.22386 2.22386 4 2.5 4H17.5C17.7761 4 18 4.22386 18 4.5C18 4.77614 17.7761 5 17.5 5H2.5C2.22386 5 2 4.77614 2 4.5ZM5.14645 7.14645C5.34171 6.95118 5.65829 6.95118 5.85355 7.14645L8.35355 9.64645C8.54882 9.84171 8.54882 10.1583 8.35355 10.3536C8.15829 10.5488 7.84171 10.5488 7.64645 10.3536L6 8.70711V15.5C6 15.7761 5.77614 16 5.5 16C5.22386 16 5 15.7761 5 15.5V8.70711L3.35355 10.3536C3.15829 10.5488 2.84171 10.5488 2.64645 10.3536C2.45118 10.1583 2.45118 9.84171 2.64645 9.64645L5.14645 7.14645ZM17.5 8H10.5C10.2239 8 10 7.77614 10 7.5C10 7.22386 10.2239 7 10.5 7H17.5C17.7761 7 18 7.22386 18 7.5C18 7.77614 17.7761 8 17.5 8Z" fill="#424242" />
  </svg>
);

export const ViewMode = {
  VIEW_LESS: 'VIEW_LESS',
  VIEW_ALL: 'VIEW_ALL',
};

export const HistoryImagesViewLess = ({
  i18n, historyList, onClick, onKeyDown, selectedIndex, onClickViewAll,
}) => {
  const latestGeneratedImages = useMemo(() => historyList[0].imageUrlList, [historyList]);

  return (
    <div className="history-images-view-less">
      <div className="view-less-image-container">
        {_.map(latestGeneratedImages, (imageUrl, index) => (
          <div
            key={`${index}`}
            className={mergeClasses('history-item-root', index === selectedIndex ? 'selected' : '')}
            onClick={() => onClick(0, index)}
            role="button"
            tabIndex={0}
            onKeyDown={e => onKeyDown(0, index, e)}
          >
            <img src={imageUrl} alt="generation history" />
          </div>
        ))}
      </div>
      {historyList.length > 1 && <Button icon={<ViewAllIcon />} onClick={onClickViewAll} appearance="transparent" className="view-all-button">{i18n.getString(_TL_('View all'))}</Button>}
    </div>
  );
};

export const HistoryImagesViewAll = ({
  i18n, historyList, onClick, onKeyDown, selectedIndex, onClickViewLess,
}) => (
  <div className="history-images-view-all">
    {_.map(historyList, ({ promptValue, imageUrlList }, index1) => (
      <div key={`${index1}`} className="view-all-image-container">
        <div className="prompt-title">{promptValue}</div>
        <div className="view-all-list-box">
          {_.map(imageUrlList, (imageUrl, index2) => {
            const currentIdx = (index1 * 4) + index2;
            return (
              <div
                key={`${index2}`}
                className={mergeClasses('history-item-root', currentIdx === selectedIndex ? 'selected' : '')}
                onClick={() => onClick(index1, currentIdx)}
                role="button"
                tabIndex={0}
                onKeyDown={e => onKeyDown(index1, currentIdx, e)}
              >
                <img src={imageUrl} alt="generation history" />
              </div>
            );
          })}
        </div>
      </div>
    ))}
    <Button icon={<ViewLessIcon />} onClick={onClickViewLess} appearance="transparent" className="view-less-button">{i18n.getString(_TL_('View less'))}</Button>
  </div>
);

